import { useRef, useEffect, DependencyList, EffectCallback } from 'react'

type EffectCallbackWithCount = (count: number) => void | (() => void)

export function useEffectWithCount(effect: EffectCallbackWithCount, deps?: DependencyList) {
  const count = useRef(0)

  useEffect(() => {
    return effect(count.current++)
  }, deps)
}
